import Authorized from './Authorized';

/**
 * An {@link Authorized} wrapper setup to just render nothing if the
 * authorization fails.
 */
export default function ComponentAuthorization(allowedRoles) {
  return Authorized(allowedRoles, () => null);
}



// WEBPACK FOOTER //
// ./src/features/rbac/Auth/ComponentAuthorization.js